/* 
	该文件专门为组件生成action对象
*/

export const adminTransfer = (data) => { return { type: 'adminTransfer', data } }